<template>
<div id="printreceipt">
    <CompanyInfo></CompanyInfo>
        
           <CompanyWatermark/>
   <div>
    <div class="content-area">
  <div class="left-column">
     <p><span class="label">Name</span><span class="colon">:</span><span class="value">{{ patientDetails.name }}</span></p>
    <p><span class="label">Age</span><span class="colon">:</span><span class="value"> {{ patientDetails.age }}</span></p>
    <p><span class="label">Gender</span><span class="colon">:</span><span class="value">{{ patientDetails.gender }} </span></p>
  </div>
  <div class="right-column">
    <p><span class="label">Date</span><span class="colon">:</span><span class="value"> {{formatDate(receiptData.receiptDate) }}</span></p>
    <p><span class="label">Reg No</span><span class="colon">:</span><span> {{ patientId }}</span></p>
    <p><span class="label">Bill No</span><span class="colon">:</span><span class="value"> {{ receiptData.receiptNo }}</span></p>
  </div>
</div>
  
           <table class="print-bill-table">
  <thead>
    <tr>
      
      <th>SI No</th>
      <th>Bill Date</th>
      <th>Bill No</th>
      <th>Due Amount</th>
      <th>Collected Amount</th>
      <th>Balance Amount</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(dues,index) in BillDueData" :key="index">
      
      <td>{{ index+1}}</td>
      <td>{{ formatDate(dues.billDate) }}</td>
      <td>{{ dues.billId }}</td>
      <td>{{ dues.dueAmount }}</td>
      <td>{{ dues.collectedAmount }}</td>
      <td>{{dues.balanceAmount }}</td>
    </tr>
  </tbody>
</table>
<hr class="full-line" />

    <div class="print-summary-block">
  <p><span class="label">Total Amount</span><span class="colon">:</span><span class="value">{{receiptData.totalAmount }}</span></p>
  
  <p><span class="label">Received Amount</span><span class="colon">:</span><span class="value">{{receiptData.receiptAmount }}</span></p>
  <p><span class="label">Balance Amount</span><span class="colon">:</span><span class="value">{{ receiptData.balanceAmount }}</span></p>
</div>
<hr class="full-line" />
   </div>
</div>
</template>

<script>
import CompanyInfo from '../components/CompanyInfo.vue';
import CompanyWatermark from '@/components/CompanyWatermark.vue'
export default {
    components: {
        CompanyInfo,
         CompanyWatermark

    },
 
    props: {
        BillDueData: 
             Array,
        receiptData: {
            type: [Object]
        },
        patientDetails: {
             type: [Object, Array]
        },
        patientId:[Number]
    },
methods: {
  formatDate(date) {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }
}
}



</script>


 <!-- <div style="margin-bottom:px;margin-top:px;">
        <p style="position: absolute;left :30px; top:100px;"><b>Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>{{recieptData.receiptDate}}</p>
        <p style="position: absolute;left :30px; top:125px;"><b>Receipt No&nbsp;&nbsp;&nbsp;:&nbsp;</b>{{recieptData.receiptNo}} </p>
        <br>
        <p style="position: absolute;left :500px; top:100px;"><b>Name&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>{{patientDetails.name}} </p>
        <br>
        <p style="position: absolute;left :500px; top:125px;"><b>Age&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>{{patientDetails.age}}</p>
        <p style="position: absolute;left :30px; top:150px;"><b>Reg No &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>{{patientId}}</p>
        <br>
        <p style="position: absolute;left :500px; top:150px;"><b>Sex&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>{{patientDetails.gender}}</p>
    </div>-->
